import {
    CantPlayReason,
    ScratchGame,
    GameFrequency,
    GameType,
} from "src/containers/wellbeing/rewards/domain/models/scratch-game";
import { DayjsUtils } from "src/libs/dayjs-utils";

export enum MockScratchGameStatus {
    CanPlay = "CAN_PLAY", // fake status,
    PreviouslyWon = "WASWINNER",
    NoStock = "ACHIEVEDSTOCK",
    UnfinishScratch = "FULFILL",
    ExceededTries = "EXCEEDEDTRIES",
}

export const rewardsMockScratchGames = new Map<
    MockScratchGameStatus,
    ScratchGame
>([
    [
        MockScratchGameStatus.PreviouslyWon,
        ScratchGame.fromJson<ScratchGame>({
            id: 1,
            description: [
                {
                    text: "¡Raspa y gana ",
                },
                {
                    text: "vales de hasta 500 soles",
                    bold: true,
                },
                {
                    text: "!",
                },
            ],
            image: "raspa-y-gana",
            frequency: GameFrequency.DAILY,
            next: DayjsUtils.today()
                .add(5, "hours")
                .add(20, "minutes")
                .add(39, "seconds"),
            allowed: false,
            type: GameType.SCRATCH,
            reason: CantPlayReason.PreviouslyWon,
        }),
    ],
    [
        MockScratchGameStatus.ExceededTries,
        ScratchGame.fromJson<ScratchGame>({
            id: 1,
            description: [
                {
                    text: "¡Raspa y gana ",
                },
                {
                    text: "vales de hasta 500 soles",
                    bold: true,
                },
                {
                    text: "!",
                },
            ],
            image: "raspa-y-gana",
            frequency: GameFrequency.DAILY,
            next: DayjsUtils.today()
                .add(5, "hours")
                .add(20, "minutes")
                .add(39, "seconds"),
            allowed: false,
            type: GameType.SCRATCH,
            reason: CantPlayReason.ExceededTries,
        }),
    ],
    [
        MockScratchGameStatus.UnfinishScratch,
        ScratchGame.fromJson<ScratchGame>({
            id: 1,
            description: [
                {
                    text: "¡Raspa y gana ",
                },
                {
                    text: "vales de hasta 500 soles",
                    bold: true,
                },
                {
                    text: "!",
                },
            ],
            image: "raspa-y-gana",
            frequency: GameFrequency.DAILY,
            next: DayjsUtils.today()
                .add(5, "hours")
                .add(20, "minutes")
                .add(39, "seconds"),
            allowed: false,
            type: GameType.SCRATCH,
            reason: CantPlayReason.UnfinishScratch,
        }),
    ],
    [
        MockScratchGameStatus.NoStock,
        ScratchGame.fromJson<ScratchGame>({
            id: 1,
            description: [
                {
                    text: "¡Raspa y gana ",
                },
                {
                    text: "vales de hasta 500 soles",
                    bold: true,
                },
                {
                    text: "!",
                },
            ],
            image: "raspa-y-gana",
            frequency: GameFrequency.DAILY,
            next: DayjsUtils.today()
                .add(5, "hours")
                .add(20, "minutes")
                .add(39, "seconds"),
            allowed: false,
            type: GameType.SCRATCH,
            reason: CantPlayReason.NoStock,
        }),
    ],
    [
        MockScratchGameStatus.CanPlay,
        ScratchGame.fromJson<ScratchGame>({
            id: 1,
            description: [
                {
                    text: "¡Raspa y gana ",
                },
                {
                    text: "vales de hasta 500 soles",
                    bold: true,
                },
                {
                    text: "!",
                },
            ],
            image: "raspa-y-gana",
            frequency: GameFrequency.DAILY,
            next: "2021-11-10 00:00:00",
            allowed: true,
            type: GameType.SCRATCH,
            reason: null,
        }),
    ],
]);
